import * as uuid from "uuid"
import { DocumentEvent } from "brandguard/brandguard.document_pb"
import { Prediction } from "brandguard/brandguard.approval_pb"

export function zero(de: Partial<DocumentEvent> = {}): DocumentEvent {
	return {
		id: uuid.NIL,
		account_id: uuid.NIL,
		brand_id: uuid.NIL,
		approved: Prediction.NONE,
		observation: Prediction.NONE,
		queue: "",
		confidence: 0.0,
		page_count: 0,
		pages_scored: 0,
		updated_at: "",
		doc_brand_voice: 0.0,
		doc_nudity: 0.0,
		doc_violence: 0.0,
		doc_racism: 0.0,
		doc_grammar: 0.0,
		doc_lookandfeel: 0.0,
		doc_logo_detection: 0.0,
		doc_font_detection: 0.0,
		doc_background_colors: 0.0,
		doc_rules: 0.0,
		artifact_score: 0.0,
		artifact_match_description: "",
		artifact_match_training_id: "",
		doc_ai_generated: 0.0,
		doc_ai_generated_explanation: "",
		...de,
	}
}
